import React, { useState, useEffect } from "react";
import poster1 from "../../assets/img/poster-ppdb.png";
import poster2 from "../../assets/img/poster-ppdb2.png";
import poster3 from "../../assets/img/poster-ppdb3.png";
import flayer1 from "../../assets/img/flayer1.png";
import flayer2 from "../../assets/img/flayer2.png";
import flayer3 from "../../assets/img/flayer3.jpg";
import flayer4 from "../../assets/img/flayer4.jpg";
import flayer5 from "../../assets/img/flayer5.jpg";
import flayer6 from "../../assets/img/flayer6.jpg";
import flayer7 from "../../assets/img/flayer7.jpg";
import flayer8 from "../../assets/img/flayer8.png";
import flayer9 from "../../assets/img/flayer9.jpg";
import flayer10 from "../../assets/img/flayer10.png";

import flayer11 from "../../assets/img/flayer11.jpeg";
import flayer12 from "../../assets/img/flayer12.png";
import flayer13 from "../../assets/img/flayer13.jpeg";
import flayer14 from "../../assets/img/flayer14.jpeg";
import flayer15 from "../../assets/img/flayer15.jpg";
import flayer16 from "../../assets/img/flayer16.jpg";
import flayer17 from "../../assets/img/flayer17.png";
import flayer18 from "../../assets/img/flayer18.jpg";
import flayer19 from "../../assets/img/flayer19.jpg";
import flayer20 from "../../assets/img/flayer20.jpg";

import flayer21 from "../../assets/img/flayer21.png";
import flayer22 from "../../assets/img/flayer22.png";
import flayer23 from "../../assets/img/flayer23.png";
import flayer24 from "../../assets/img/flayer24.jpg";
import flayer25 from "../../assets/img/flayer25.png";
import flayer26 from "../../assets/img/flayer26.png";
import flayer27 from "../../assets/img/flayer27.png";
import flayer28 from "../../assets/img/flayer28.jpg";
import flayer29 from "../../assets/img/flayer29.jpeg";
import flayer30 from "../../assets/img/flayer30.png";

import flayer31 from "../../assets/img/flayer31.png";
import flayer32 from "../../assets/img/flayer32.png";
import flayer33 from "../../assets/img/flayer33.png";
import flayer34 from "../../assets/img/flayer34.jpeg";
import flayer35 from "../../assets/img/flayer35.jpeg";

import logo from "../../assets/img/logo.png";
import icon_chat from "../../assets/img/icon_chat.png";
import icon_tanya from "../../assets/img/icon_tanya.png";
import icon_info from "../../assets/img/icon_info.png";
import icon_arrow from "../../assets/img/icon_arrow.png";
import icon_wa from "../../assets/img/icon_wa.png";
import "./style.css";

export default function Main() {
  const [currentPoster, setCurrentPoster] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);
  // const posters = [poster1, poster2, poster3];
  const posters = [flayer1, flayer2, flayer3, flayer4, flayer5, flayer6, flayer7, flayer8, flayer9, flayer10, flayer11, flayer12, flayer13, flayer14, flayer15, flayer16, flayer17, flayer18,flayer19, flayer20, flayer21, flayer22, flayer23, flayer24, flayer25, flayer26, flayer27, flayer28, flayer29, flayer30, flayer31, flayer32, flayer32, flayer33, flayer34, flayer35];

  const handlePopupCardClick = (type) => {
    const waNumber = '62811356679';
    
    if (type === 'kendala-teknis') {
      const message = encodeURIComponent('Halo, saya ingin bertanya tentang kendala teknis PMBM JPPT');
      window.open(`https://wa.me/${waNumber}?text=${message}`, '_blank');
    } else if (type === 'informasi-pmbm') {
      const message = encodeURIComponent('Halo, saya ingin bertanya tentang informasi PMBM JPPT');
      window.open(`https://wa.me/${waNumber}?text=${message}`, '_blank');
    }
    
    setOpenPopup(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPoster((prev) => (prev + 1) % posters.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const jalurData = [
    { nama: "MI", link: "https://pmbm-mi.jogjamadrasahdigital.net/" },
    { nama: "MTs", link: "https://pmbm-mts.jogjamadrasahdigital.net/" },
    { nama: "MA", link: "https://pmbm-ma.jogjamadrasahdigital.net/" },
  ];

  // Cek apakah mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showModal, setShowModal] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(null);
  const [popupView, setPopupView] = useState("menu");
  const closePopup = () => {
    setOpenPopup(false);
    setPopupView("menu");
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <main className="main-content">
      <div className="container main-wrapper">
        {/* LEFT SECTION */}
        <section className="main-left">
          <div className="brand-heading">
            <img src={logo} alt="Logo Kemenag" className="brand-logo" />
            <div className="brand-text-group">
              <div className="brand-subtitle">
                Selamat Datang di PMBM JPPT (Penerimaan Murid Baru Madrasah
                Jalur Pendaftaran Tahfidz Terpadu)
              </div>
              <h1 className="brand-title">
                Kanwil Kementerian Agama DIY
                <br />
                <span>Tahun Ajaran 2026 / 2027</span>
              </h1>
            </div>
          </div>

          <p className="main-desc">
            Sistem ini digunakan untuk mendukung pelaksanaan Penerimaan Murid
            Baru Madrasah (PMBM) melalui{" "}
            <b>Jalur Pendaftaran Tahfidz Terpadu (JPPT)</b> di lingkungan Kanwil
            Kementerian Agama D.I. Yogyakarta, dengan mekanisme pendaftaran
            secara daring serta tahapan seleksi dan tes yang dilaksanakan secara
            luring.
          </p>

          {/* TIMELINE */}
          <div className="timeline">
            <div className="timeline-card">
              <span>Pendaftaran dibuka</span>
              <b>3 Maret 2026 pukul 08:00 WIB - 5 Maret 2026 pukul 15:00 WIB</b>
            </div>
            <div className="timeline-card">
              <span>Pengumuman Tahap I</span>
              <b>6 Maret 2026</b>
            </div>
            <div className="timeline-card">
              <span>Seleksi Tahap II</span>
              <b>9 - 10 Maret 2026</b>
            </div>
            <div className="timeline-card">
              <span>Pengumuman Tahap II</span>
              <b>11 Maret 2026</b>
            </div>
            <div className="timeline-card">
              <span>Lapor Diri</span>
              <b>11 - 12 Maret 2026</b>
            </div>
          </div>

          {/* JALUR CARDS */}
          <div className="jalur-section">
            {jalurData.map((j) => (
              <div key={j.nama} className="jalur-card">
                <h3>{j.nama}</h3>
                <div className="jalur-line"></div>
                <p className="jalur-subtitle">1 Jalur</p>
                <p className="jalur-text">Pendaftaran</p>
                <a
                  href={j.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-jalur"
                >
                  Lihat Selengkapnya <span className="arrow">→</span>
                </a>
              </div>
            ))}
          </div>

          <p className="jalur-note">
            <b>JPPT (Jalur Pendaftaran Tahfidz Terpadu) adalah</b> jalur
            penerimaan peserta didik baru yang mengutamakan calon peserta didik
            dengan prestasi hafalan Al-Qur'an.
          </p>
        </section>

        {/* RIGHT SECTION */}
        <section className="main-right">
          <div className="poster-container">
            <img
              src={posters[currentPoster]}
              alt="Poster PMBM"
              className="poster-img"
              onClick={() => {
                setPreviewIndex(currentPoster);
                setShowModal(true);
              }}
            />

            <div className="poster-dots">
              {posters.slice(0, 3).map((_, i) => (
                <span
                  key={i}
                  className={i === currentPoster ? "dot active" : "dot"}
                  onClick={() => setCurrentPoster(i)}
                />
              ))}
            </div>
          </div>
          {showModal && previewIndex !== null && (
            <div className="poster-modal" onClick={() => setShowModal(false)}>
              <div
                className="poster-modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="poster-close"
                  onClick={() => setShowModal(false)}
                >
                  ✕
                </button>

                <img src={posters[previewIndex]} alt="Poster Preview" />
              </div>
            </div>
          )}
        </section>
      </div>

      {/* FLOATING BUTTON - HANYA DI DESKTOP */}
      {!isMobile && (
        <button
          className={`btn-tanya-floating ${openPopup ? "btn-close-state" : ""}`}
          onClick={() => setOpenPopup(!openPopup)}
        >
          {openPopup ? (
            <>✕ Close</>
          ) : (
            <>
              <img src={icon_chat} alt="Chat" className="btn-icon" />
              Tanya PMBM
            </>
          )}
        </button>
      )}

      {/* POPUP CHAT - DESKTOP (KANAN BAWAH) */}
      {!isMobile && openPopup && (
        <div className="popup-chat">
          <div className="popup-header">
            <h3>
              {popupView === "menu"
                ? "Bagaimana kami dapat membantu Anda terkait PMBM?"
                : "Informasi PMBM"}
            </h3>

            <button
              className="close-icon"
              onClick={() => {
                setOpenPopup(false);
                setPopupView("menu");
              }}
            >
              ✕
            </button>
          </div>

          <div className="popup-body">
            {popupView === "menu" && (
              <>
                {/* Kendala Teknis */}
                <div
                  className="popup-card"
                  onClick={() => handlePopupCardClick("kendala-teknis")}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handlePopupCardClick("kendala-teknis");
                    }
                  }}
                >
                  <div className="card-icon">
                    <img src={icon_tanya} alt="Kendala Teknis" />
                  </div>
                  <div className="card-content">
                    <div className="card-title">
                      Kendala Teknis
                      <span className="card-arrow">
                        <img src={icon_arrow} alt="arrow" />
                      </span>
                    </div>
                    <p>
                      Masalah terkait pendaftaran, login, pengisian data, atau
                      gangguan sistem.
                    </p>
                  </div>
                </div>

                <div
                  className="popup-card"
                  onClick={() => setPopupView("informasi")}
                  role="button"
                >
                  <div className="card-icon">
                    <img src={icon_info} alt="Informasi PMBM" />
                  </div>
                  <div className="card-content">
                    <div className="card-title">
                      Informasi PMBM
                      <span className="card-arrow">
                        <img src={icon_arrow} alt="arrow" />
                      </span>
                    </div>
                    <p>
                      Pertanyaan seputar persyaratan, jadwal, tahapan seleksi,
                      atau pengumuman.
                    </p>
                  </div>
                </div>

                {/* WhatsApp Info */}
                <div className="popup-wa">
                  <img src={icon_wa} alt="WhatsApp" color="#25D366" />
                  <span>Kami akan menghubungkan Anda melalui WhatsApp</span>
                </div>
              </>
            )}

            {popupView === "informasi" && (
              <div className="popup-info-content">
                <p>
                  Untuk informasi lebih lanjut terkait PMBM, silakan menghubungi
                  madrasah yang di daftar kunjungi link dibawah ini.
                </p>

                <a
                  href="https://docs.google.com/spreadsheets/d/1WsnkruZikvMySsazFay7vQm6zhgM9wY1/edit?usp=sharing&ouid=107731123210521055052&rtpof=true&sd=true"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-info-link"
                >
                  Link Contact Person
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      {/* POPUP MODAL - MOBILE (TENGAH LAYAR) */}
      {isMobile && (
        <>
          <button
            className="btn-tanya-mobile"
            onClick={() => setOpenPopup(true)}
          >
            Tanya PMBM
          </button>

          {openPopup && (
            <div className="popup-overlay-mobile" onClick={closePopup}>
              <div
                className="popup-chat-mobile"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="popup-header">
                  <h3>
                    {popupView === "menu"
                      ? "Bagaimana kami dapat membantu Anda terkait PMBM?"
                      : "Informasi PMBM"}
                  </h3>

                  <button className="close-icon" onClick={closePopup}>
                    ✕
                  </button>
                </div>

                <div className="popup-body">
                  {popupView === "menu" && (
                    <>
                      <div
                        className="popup-card"
                        onClick={() => handlePopupCardClick("kendala-teknis")}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            handlePopupCardClick("kendala-teknis");
                          }
                        }}
                      >
                        <div className="card-icon">
                          <img src={icon_tanya} alt="Kendala Teknis" />
                        </div>
                        <div className="card-content">
                          <div className="card-title">
                            Kendala Teknis
                            <span className="card-arrow">
                              <img src={icon_arrow} alt="arrow" />
                            </span>
                          </div>
                          <p>
                            Masalah terkait pendaftaran, login, pengisian data,
                            atau gangguan sistem.
                          </p>
                        </div>
                      </div>

                      {/* Informasi PMBM */}
                      <div
                        className="popup-card"
                        onClick={() => setPopupView("informasi")}
                      >
                        <div className="card-icon">
                          <img src={icon_info} alt="Informasi PMBM" />
                        </div>
                        <div className="card-content">
                          <div className="card-title">
                            Informasi PMBM
                            <span className="card-arrow">
                              <img src={icon_arrow} alt="arrow" />
                            </span>
                          </div>
                          <p>
                            Pertanyaan seputar persyaratan, jadwal, tahapan
                            seleksi, atau pengumuman.
                          </p>
                        </div>
                      </div>

                      {/* WhatsApp Info */}
                      <div className="popup-wa">
                        <img src={icon_wa} alt="WhatsApp" />
                        <span>
                          Kami akan menghubungkan Anda melalui WhatsApp
                        </span>
                      </div>
                    </>
                  )}

                  {popupView === "informasi" && (
                    <div className="popup-info-content">
                      <p>
                        Untuk informasi lebih lanjut terkait PMBM, silakan
                        menghubungi madrasah yang di daftar kunjungi link
                        dibawah ini.
                      </p>

                      <a
                        href="https://docs.google.com/spreadsheets/d/1WsnkruZikvMySsazFay7vQm6zhgM9wY1/edit?usp=sharing&ouid=107731123210521055052&rtpof=true&sd=true"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-info-link"
                      >
                        Link Contact Person
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </main>
  );
}
